
// src/web/components/diary-mentions-by.jsx

import React from 'react'
import { themr } from 'react-css-themr'
import { translate } from 'react-i18next'
import diaryTheme from './themes/diary.css'
import Tooltip from 'react-toolbox/lib/tooltip'
import {
  Button,
} from 'react-toolbox/lib/button'
import Avatar from 'react-toolbox/lib/avatar'
import {
  FontIcon,
} from 'react-toolbox/lib/font_icon'

const TooltipButton = Tooltip(Button)

@themr('Diary', diaryTheme)
class DiaryMentionsBy extends React.Component {
  render() {
    const {
      t,
      mentions,
      theme,
      showReaders,
    } = this.props

    if (!mentions || mentions.length == 0)
      return null

    var tooltip = mentions.map((mention)=>
          <div key={mention.user_id}>
            <Avatar key={mention.user_id} image={mention.icon_image.thumb_url} theme={theme} />
            &nbsp;
            {mention.name}
          </div>)

    return <TooltipButton neutral={false} ripple={false}
              theme={theme}
              className="touchable"
              tooltipPosition="vertical"
              tooltip={tooltip}
              onClick={() => showReaders({types: 'mentions'})}>
            <FontIcon value="priority_high" style={{ fontSize: 16, color: 'orange', lineHeight: '1' }} />&nbsp;
            {mentions.slice(0, 3).map((mention)=> 
                <Avatar key={mention.user_id} image={mention.icon_image.thumb_url} theme={theme} />)}
            &nbsp;
            {mentions.length > 3 &&
                t('label:他n人', { n: mentions.length - 3 })}
            {t('label:が読んでみて')}
          </TooltipButton>
  }
}

export default translate()(DiaryMentionsBy)



// WEBPACK FOOTER //
// ./src/web/components/diary-mentions-by.jsx